module.exports = __webpack_public_path__ + "img/imagetwo.cae75464.jpg";